/**
 * Component for coupling external product links with the variant picker.
 */
if (!customElements.get('sibling-links')) {
  class PreloadLinks extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('button').forEach((link) => {
        link.addEventListener('mouseenter', this.handleMouseEnter.bind(this), { once: true });
        link.addEventListener('focus', this.handleFocus.bind(this), { once: true });
        link.addEventListener('click', this.handleClick.bind(this), { once: false });
      });

      this.toggleAttribute('active', true);
    }

    /**
     * Handles the mouse enter event on a link.
     * @param {object} evt - Event object.
     */
    handleMouseEnter(evt) {
      this.preload(evt.currentTarget);
    }

    /**
     * Handles the focus event on a link.
     * @param {object} evt - Event object.
     */
    handleFocus(evt) {
      this.preload(evt.currentTarget);
    }

    /**
     * Handles the click event on a link.
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
      evt.preventDefault();
      const zielUrl = evt.currentTarget.dataset.productUrl;

      if (this.closest('.product--featured') && evt.isTrusted) {
        window.location.href = zielUrl;
        return;
      }

      // AVS 31.08.2026 (AU-021): Auf der Produktseite ist der Pack-Wechsel ein
      // PRODUKTwechsel — 6er/12er/Einzelflasche sind eigene Shopify-Produkte mit
      // eigenen Vorlagen. Der In-Place-Tausch erneuert nur die Produkt-Sektion;
      // FAQ, Fliesstexte, URL und das FAQPage-JSON-LD blieben auf dem Produkt
      // stehen, das der Kunde aufgerufen hatte (gemessen an aloe.eu, alle drei
      // Trinkgel-Familien: tests/sibling-wechsel-mess.mjs).
      //
      // Kein evt.isTrusted-Test: das Dropdown loest diesen Klick synthetisch aus
      // (dual-swatch-selector.js -> link.click()), ein isTrusted-Test wuerde
      // genau diesen Weg verfehlen. Im Quick-Buy-Fenster bleibt der Tausch
      // richtig, dort gibt es keine Seite darunter.
      if (zielUrl && !this.closest('.js-quickbuy')
          && zielUrl.split('?')[0] !== window.location.pathname) {
        window.location.href = zielUrl;
        return;
      }

      const vp = this.closest('.shopify-section, .js-quickbuy').querySelector('variant-picker');
      vp.handleVariantChange({
        target: evt.currentTarget
      });
    }

    /**
     * Handle preloading this link.
     * @param {HTMLElement} link - Link to preload.
     */
    preload(link) {
      const vp = this.closest('.shopify-section, .js-quickbuy').querySelector('variant-picker');
      vp.handleLabelMouseEnter({
        currentTarget: link
      });
    }
  }

  customElements.define('sibling-links', PreloadLinks);
}
